// apiSlice.js
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { BASE_URL } from '../components/constants';

// Thunk for user files
// apiSlice.js
export const fetchUserFiles = createAsyncThunk(
    'api/fetchUserFiles',
    async ({userId, historyId}) => {
      if (!userId || !historyId) return { files: [], total_files: 0 };
      const response = await fetch(`${BASE_URL}/files/${userId}/${historyId}`);
    
      const data = await response.json();
      console.log(data, response)
      return data;
    }
  );
// You can add other API calls here
// export const anotherApiCall = createAsyncThunk(...)

const apiSlice = createSlice({
  name: 'api',
  initialState: {
    userFiles: [], // changed from files to userFiles
    userFilesStatus: 'idle', // changed from status to userFilesStatus
    userFilesError: null, // changed from error to userFilesError
    // You can add more API-related states here
  },
  reducers: {
    clearUserFiles: (state) => {
      state.userFiles = [];
      state.userFilesStatus = 'idle';
      state.userFilesError = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchUserFiles.pending, (state) => {
        state.userFilesStatus = 'loading';
      })
      .addCase(fetchUserFiles.fulfilled, (state, action) => {
        state.userFilesStatus = 'succeeded';
        state.userFiles = action.payload;
      })
      .addCase(fetchUserFiles.rejected, (state, action) => {
        state.userFilesStatus = 'failed';
        state.userFilesError = action.error.message;
      });
    
    // You can add more API cases here
  }
});

export default apiSlice.reducer;
export const { clearUserFiles } = apiSlice.actions;